import script from "./terms-of-service.vue?vue&type=script&setup=true&lang=js"
export * from "./terms-of-service.vue?vue&type=script&setup=true&lang=js"

import "./terms-of-service.vue?vue&type=style&index=0&id=8356f04e&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8356f04e"]])

export default __exports__